// Full-document render of the password-reset request view: PageSkeleton (the
// React document shell) wrapping PasswordResetBody.
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { PasswordResetBody } from "../components/PasswordResetBody";

export const Template = (
    props: templates.PasswordResetDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <PasswordResetBody {...props} />
    </PageSkeleton>
);
